// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
// 这里面文件导入顺序决定样式的覆盖
import Vue from "vue";
import router from "./router";

import ElementUI from "element-ui";
Vue.use(ElementUI);

import "element-ui/lib/theme-chalk/index.css";
import "./assets/fonts/iconfont.css";
import "./style/animateStyle.css";
import animated from "animate.css";
Vue.use(animated);

import { observeView } from "./utils/observeView.js";
// Vue.use(observeView)

import Loading from "@/components/loading.js";

Vue.use(Loading);

import App from "./App";

Vue.config.productionTip = false;
Vue.mixin({
  mounted() {
    //开启监听
    observeView.start();
  },
  beforeDestroy() {
    // 离开时断开监听
    observeView.disconnect();
  },
});
/* eslint-disable no-new */
new Vue({
  el: "#app",
  router,
  components: { App },
  template: "<App/>",
});



// WEBPACK FOOTER //
// ./src/main.js